export const OPEN_TECH_SUPPORT_MENU_EVENT = 'help-menu:open-tech-support';

/** Открывает существующую панель техподдержки, закреплённую за кнопкой «Помощь» в шапке. */
export const openTechSupportMenu = (): void => {
    window.dispatchEvent(new Event(OPEN_TECH_SUPPORT_MENU_EVENT));
};
